
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
    import { Situacion } from '@/__env/lib/Pantalla/Situacion';
    import { Empresa } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';
    import moment from 'moment';

    import { WaitEntre } from '@/__env/ext';
    import { FavoritosPantalla } from '@/__env/lib/Pantalla/Favoritos';
    import { EstadisticaVentas, Articulo } from '@/__env/lib/Articulos';
    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Model; }

        @Prop()
        public Item: EstadisticaVentas;

        @Prop()
        public Posicion: number;


        protected Eventos: Function[] = [];
        beforeDestroy()
        {

            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {
            this.Eventos.push( this.Controlador.onActualizarFavoritos.subscribe( () => this.Refrescar() ) );
        }


        public Seleccionar( x: Articulo )
        {
            this.Controlador.ArticuloSeleccionado = x;
            this.Controlador.Vista.Modo = 'articulo';
        }

        public Refresh: boolean = true;
        public Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => { this.Refresh = true; } );
        }
    }
